import axios, { AxiosResponse } from 'axios';
import { apiClient } from './apiClient';

export interface VersionNote {
    _id: string;
    version: string;
    versionName: string;
    date: string;
    newFeatures: string;
    upgrades: string;
    bugsCorrections: string;
    security: string;
    type: number;
    createdAt: string;
    updatedAt: string;
}

export interface VersionNotesResponse {
    data: VersionNote[];
    message: string;
}

export interface VersionNoteResponse {
    data: VersionNote;
    message: string;
}

export interface GetAllVersionNotesParams {
    type?: number;
}

export const getAllVersionNotes = async (queries?: GetAllVersionNotesParams): Promise<VersionNotesResponse> => {
    try {
        const response: AxiosResponse<VersionNotesResponse> = await apiClient.get('/version-notes', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const getCurrentVersionNote = async (): Promise<VersionNoteResponse> => {
    try {
        const response: AxiosResponse<VersionNoteResponse> = await apiClient.get('/version-notes/current');
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface CreateVersionNoteBody {
    version: string;
    versionName: string;
    date: string;
    newFeatures: string;
    upgrades: string;
    bugsCorrections: string;
    security: string;
    type: number;
}

export const createVersionNote = async (body: CreateVersionNoteBody): Promise<VersionNoteResponse> => {
    try {
        const response: AxiosResponse<VersionNoteResponse> = await apiClient.post('/version-notes', body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface UpdateVersionNoteBody {
    version?: string;
    versionName?: string;
    date?: string;
    newFeatures?: string;
    upgrades?: string;
    bugsCorrections?: string;
    security?: string;
    type?: number;
}

export const updateVersionNote = async (id: string, body: UpdateVersionNoteBody): Promise<VersionNoteResponse> => {
    try {
        const response: AxiosResponse<VersionNoteResponse> = await apiClient.patch(`/version-notes/${id}`, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
